import React, {Component} from 'react';
import {Col, Row} from 'antd';
import {Link, Route, Switch} from 'react-router-dom';
import Head from '../components/Head';
import Bg from '../components/Bg';
import ICP from '../components/ICP';
import LIndex from "./login/Index";
import FirstLogin from "./login/FirstLogin";
import '../css/login.css';
import y_icp from "../assets/y-icp.png";

class Login extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        return (
            <div className="login">
                <Head history={this.props.history} height="5rem"/>
                <div style={{height: "1rem"}}></div>
                <Bg/>
                <Switch>
                    <Route exact path="/login/first" component={FirstLogin}/>
                    <Route component={LIndex}/>
                </Switch>
                <Row style={{width: "100%", position: "absolute", left: 0, bottom: 0}}>
                    {/*<ICP/>*/}
                    <div style={{ width: '400px',margin:'0 auto',color: '#fff' }}>
                        <Row style={{ width: '100%',paddingBottom:'10px' }}>
                            <Col span={10} className="fi-left">存心救援信息公开平台</Col>
                            <Col span={14} className="fi-left">技术支持及运营: 奥讯新媒体</Col>
                            {/*<Col span={12} className="fi-left">存心救援信息公开平台丨<a href="https://beian.miit.gov.cn" target="_blank" style={{color: '#fff'}}>粤B2-20051036号</a>丨技术支持及运营: 奥讯新媒体</Col>*/}
                            <Col span={10} className="fi-right">
                                <a href="https://beian.miit.gov.cn" target="_blank" style={{color: '#fff'}}>粤B2-20051036号</a>
                            </Col>
                            {/*<Col span={14} className="fi-right">*/}
                            {/*    <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44060402002204" style={{height:'20px',lineHeight:'20px'}}><img src={y_icp} style={{float:'left'}}/><p style={{float:'left',height:'20px',lineHeight:'20px',margin:'0px 0px 0px 5px',color:'#FFF'}}>粤公网安备 44060402002204号</p></a>*/}
                            {/*</Col>*/}
                        </Row>
                    </div>
                </Row>
            </div>
        );
    }
}

export default Login;



// WEBPACK FOOTER //
// ./src/routes/Login.jsx